import * as React from 'react'
import {useHistory} from 'react-router-dom'
import { LoadingIndicator } from '../../LoadingIndicator';
import axios from '../../services/index'

//This component allow Admin to edit an existing Training
export const EditTraining: React.FunctionComponent = (props) => {

    interface ITraining {
        title : any,
        description: any,
        presentationVideoLink: any,
        price: any,
        videoLink: any,
        pdfLink: any,
        facebookLink: any,
        googleFormLink: any,
        duration: any,
        pedagogicalMethods: any,
        objectives: any,
        detailledProgram: any,
        prerequisite: any,
    }

    let emptyTraining: ITraining = {
        title: '',
        description: '',
        presentationVideoLink: '',
        price: '',
        videoLink: '',
        pdfLink: '',
        facebookLink: '',
        googleFormLink: '',
        duration: '',
        pedagogicalMethods: '',
        objectives: '',
        detailledProgram: '',
        prerequisite: '',
    }

    const trainingId = window.location.href.toString().split('/')[6]
    const currentToken = localStorage.getItem('access_token')
    const [training, setTraining] = React.useState<ITraining>(emptyTraining)
    const [submitted, setSubmitted] = React.useState(false)
    let addTrainingJSON: any = {}
    let history = useHistory()

    React.useEffect(() => {
        axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/admintraining/${trainingId}/`, {
            headers: {
                "Authorization" : `Bearer ${currentToken}`
            }
        })
        .then(function(response) {
            const requestTraining: ITraining = {
                title: response.data.title,
                description: response.data.description,
                presentationVideoLink: response.data.presentationVideoLink,
                price: response.data.price,
                videoLink: response.data.videoLink,
                pdfLink: response.data.pdfLink,
                facebookLink: response.data.facebookLink,
                googleFormLink: response.data.googleFormLink,
                duration: response.data.duration,
                pedagogicalMethods: response.data.pedagogicalMethods,
                objectives: response.data.objectives,
                detailledProgram: response.data.detailledProgram,
                prerequisite: response.data.prerequisite,
            }
            setTraining(requestTraining)
        })
        .catch(function(error) {
            console.log(error)
            alert("Une erreur est survenue ! Veuillez réessayer")
        })
    },[])

    const submitAddTraining= () => {

        let form_data = new FormData();

        for (let key in addTrainingJSON) {
            form_data.append(key, addTrainingJSON[key])
        }

        axios.patch(`https://LaurenceBrun.eu.pythonanywhere.com/admintrainingadd/${trainingId}/`, form_data,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        )
        .then(function (response) {
            history.push('/admin')
        })
        .catch(function(erreur) {
            setSubmitted(false)
            console.log(erreur.response)
            alert("Une erreur est survenue ! Veuillez réessayer")
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        setSubmitted(true)
        let isPriceOk = true
        if (event.target.title.value && event.target.description.value && event.target.price.value && event.target.videoPresentationLink.value && event.target.videoLink.value && event.target.facebookLink.value && event.target.googleFormLink.value && event.target.duration.value && event.target.pedagogicalMethods.value && event.target.objectives.value && event.target.detailledProgram.value && event.target.prerequisite.value){
            let price = event.target.price.value
            if (price.indexOf(',') >= 0) {
                price = price.replace(',', '.')
            }
            else if (price.indexOf('.') <= 0) {
                alert('Précisez les centimes sur le prix !')
                isPriceOk = false
            }
            else if (price.split('.')[1].length > 2) {
                alert('Trop de chiffres pour les centimes !')
                isPriceOk = false
            }
            
            if(isPriceOk) {
                price = parseFloat(price).toFixed(2)
            }

            addTrainingJSON = {
                "title": event.target.title.value,
                "description": event.target.description.value,
                "price": price,
                "presentationVideoLink": event.target.videoPresentationLink.value,
                "videoLink": event.target.videoLink.value,
                "facebookLink": event.target.facebookLink.value,
                "googleFormLink": event.target.googleFormLink.value,
                "duration": event.target.duration.value,
                "pedagogicalMethods": event.target.pedagogicalMethods.value,
                "objectives": event.target.objectives.value,
                "detailledProgram": event.target.detailledProgram.value,
                "prerequisite": event.target.prerequisite.value,
            }

            if (event.target.pdfLink.files[0]) {
                let fileToSend = event.target.pdfLink.files[0]
                addTrainingJSON = {...addTrainingJSON, pdfLink: fileToSend}
            }

            if(isPriceOk){
                submitAddTraining()
            }
        }
        else{
            alert('Vous devez remplir tous les champs (sauf pdf) !')
        }
    }

    //Display loader during processing of requests
    const isLoading = () => {
        if (submitted) {
            return(
                <div className="Loading">
                    <div className="Loader"><LoadingIndicator /></div>
                </div>
            )
        }
    }

    return(
        <div className="Connect">
            {isLoading()}
            <h2>Modification d'une formation</h2>
            <form onSubmit={handleSubmit}>
                <label> <span className="asPlaceholder">Titre Formation : </span>
                    <input type="text" name="title" defaultValue={training?.title} />
                </label><br />
                <label> <span className="asPlaceholder">Présentation vidéo : </span>
                    <input type="text" name="videoPresentationLink" defaultValue={training?.presentationVideoLink}/>
                </label><br />
                <label> <span className="asPlaceholder">Prix de la formation : </span>
                    <input type="text" name="price" defaultValue={training?.price} />
                </label><br />
                <label> <span className="asPlaceholder">Vidéo de formation : </span>
                    <input type="text" name="videoLink" defaultValue={training?.videoLink} />
                </label><br />
                <label> <span className="asPlaceholder">Groupe Facebook : </span>
                    <input type="text" name="facebookLink" defaultValue={training?.facebookLink} />
                </label><br />
                <label> <span className="asPlaceholder">Google Form : </span>
                    <input type="text" name="googleFormLink" defaultValue={training?.googleFormLink} />
                </label><br />
                <label> <span className="asPlaceholder">Description de la Formation : </span>
                    <textarea rows={5} cols={50}name="description" defaultValue={training?.description} />                    
                </label><br />
                <label> <span className="asPlaceholder">Durée de la Formation : </span>
                    <textarea rows={5} cols={50}name="duration" defaultValue={training?.duration} />                    
                </label><br />
                <label> <span className="asPlaceholder">Objectifs de la Formation* : </span>
                    <textarea rows={5} cols={50}name="objectives" defaultValue={training?.objectives} />                    
                </label><br />
                <label> <span className="asPlaceholder">Programme Détaillé de la Formation* : </span>
                    <textarea rows={5} cols={50}name="detailledProgram" defaultValue={training?.detailledProgram} />                    
                </label><br />
                <label> <span className="asPlaceholder">Méthodes Pédagogiques* : </span>
                    <textarea rows={5} cols={50}name="pedagogicalMethods" defaultValue={training?.pedagogicalMethods} />                    
                </label><br />
                <label> <span className="asPlaceholder">Prérequis de la Formation* : </span>
                    <textarea rows={5} cols={50}name="prerequisite" defaultValue={training?.prerequisite} />                    
                </label><br />
                <label> <span className="asPlaceholder">Ne mettre un fichier que pour remplacer l'actuel PDF : </span>
                    <input type="file" name="pdfLink"/>
                </label><br />
                <input type="submit" value="modifier" className="ConnectButton Connexion" />
            </form>
            <div>*: séparer les items par le symbole _ pour un retour à la ligne</div>
        </div>
    )
}